// extracted by mini-css-extract-plugin
export default {"unselected":"Move_unselected__mZBCz","card":"Move_card__YDArs","card-header":"Move_card-header__HpdLT","card-footer":"Move_card-footer__2MDBK"};